const HoverRect = ({ innerWidth, innerHeight, hasMouse, showFunction, hideFunction }) => {

    const touchMoveFunction = (event) => {
        if (hasMouse) return;
        const touch = event.touches[0];
        const targetedElement = document.elementFromPoint(touch.pageX,touch.pageY);
        if (!targetedElement || targetedElement.id !== 'hover-rect'){
            hideFunction();
            return;
        };
        showFunction(event);

    }

    return (
            <rect
                id='hover-rect'
                width={innerWidth}
                height={innerHeight}
                opacity='0'
                onMouseMove={(event) => { if (hasMouse) showFunction(event) }}
                onMouseLeave={hideFunction}
                onTouchStart={(event) => { if (hasMouse === false) showFunction(event) }}
                onTouchMove={touchMoveFunction}
                onTouchEnd={hideFunction}
                onTouchCancel={hideFunction}
            />
    )

}

export default HoverRect;